import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, BadgeCheck } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

export const ReservationPopups = () => {
  const { t, lang } = useLanguage();
  const [index, setIndex] = useState(-1);

  const messages = [t.popup_1, t.popup_2, t.popup_3];

  useEffect(() => {
    let hideTimer;
    const showTimer = setTimeout(() => setIndex(0), 6000);
    const cycle = setInterval(() => {
      setIndex((i) => (i + 1) % messages.length);
    }, 24000);
    return () => {
      clearTimeout(showTimer);
      clearInterval(cycle);
      clearTimeout(hideTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang]);

  useEffect(() => {
    if (index < 0) return;
    const hide = setTimeout(() => setIndex(-1), 8000);
    return () => clearTimeout(hide);
  }, [index]);

  return (
    <div className="fixed bottom-5 start-5 z-[70] max-w-[300px] pointer-events-none">
      <AnimatePresence>
        {index >= 0 && (
          <motion.div
            key={`${lang}-${index}`}
            data-testid="reservation-popup-badge"
            initial={{ opacity: 0, y: 24, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 16, scale: 0.96 }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            className="pointer-events-auto flex items-start gap-3 p-4 bg-[#0C0C0C]/95 backdrop-blur-md border border-[rgba(197,160,89,0.4)] shadow-[0_16px_50px_rgba(0,0,0,0.7)]"
          >
            <span className="mt-0.5 shrink-0 text-[#C5A059]">
              <BadgeCheck size={18} />
            </span>
            <div className="min-w-0">
              <span className="block text-[10px] tracking-[0.24em] uppercase text-[#C5A059]">{t.popup_label}</span>
              <span className="block mt-1 text-xs text-[#E8DDC5] leading-relaxed">{messages[index]}</span>
            </div>
            <button
              data-testid="reservation-popup-close-btn"
              onClick={() => setIndex(-1)}
              aria-label={t.popup_close}
              className="shrink-0 text-[#8A8270] hover:text-[#EED8A1] transition-colors"
            >
              <X size={14} />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
